import React from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  Spinner,
  Box,
  Text,
  Center,
} from "@chakra-ui/react";
import ReactDiffViewer from "react-diff-viewer-continued";
import { common } from "../../constants/constants";

export default function LogModal({ isOpen, onClose, logData, loading }) {
  const oldData = logData?.changes?.old_data || logData?.old_data || {};
  const newData = logData?.changes?.new_data || logData?.new_data || {};
  
  const customStyles = {
    diffContainer: {
      fontFamily: 'monospace',
      fontSize: '14px',
      whiteSpace: 'pre-wrap', // Enables wrapping
      wordBreak: 'break-word', // Prevents overflow
    },
  };
  
  return (
    <Modal isOpen={isOpen} onClose={onClose} size="6xl" isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{common.LOG_HISTORY}</ModalHeader>
        <ModalCloseButton />
        <ModalBody minH="400px" maxH="600px" overflowY="auto">
          {loading ? (
            <Center minH="400px">
              <Box textAlign="center">
                <Spinner size="xl" color="blue.500" thickness="4px" />
                <Text mt={4} color="gray.500" fontSize="md" fontWeight="500">
                  Loading audit log details...
                </Text>
              </Box>
            </Center>
          ) : logData ? (
          <div style={customStyles.diffContainer}>
          <ReactDiffViewer
            newValue={JSON.stringify(newData, null, 2)}
            oldValue={JSON.stringify(oldData, null, 2)}
            splitView={true}
            showDiffOnly={false}
            leftTitle="Old Data"
            rightTitle="New Data"
          />
          </div>
          ) : (
            <Center minH="400px">
              <Text color="gray.500" fontSize="md">
                No data available
              </Text>
            </Center>
          )}
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}
